<template>
    <div :id="id">
        <PtCheckbox
            v-model="fieldValue"
            @change="syncChange"
        >
            <span class="search-preferences--value">{{ $t(fieldConfig.label) }}</span>
        </PtCheckbox>
        <ElPopover
            placement="right"
            trigger="hover"
            :visible-arrow="false"
            :width="366"
            popper-class="bio-search-setting__popover"
        >
            <div class="preferences-propver__content">
                <p>{{ $t('Search.propver.Preferences.lowComplexRegion') }}</p>
            </div>

            <PtIcon
                slot="reference"
                icon="SolidInfo"
            />
        </ElPopover>
    </div>
</template>

<script>
import Checkbox from 'element-ui/lib/checkbox';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import { FieldItemMixin } from './mixins';

export default {
    components: {
        ElPopover: Popover,
        PtCheckbox: Checkbox,
        PtIcon,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'low_complexity_region',
        },
    },
};
</script>
